var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:_vm.itemClasses(item.selected),on:{"click":function($event){return _vm.click(item)}}},[_c('span',{staticClass:"normal-part"},[_vm._v(_vm._s(_vm.getNormalPart(item.value)))]),_c('span',{staticClass:"bold-part"},[_vm._v(_vm._s(_vm.getBoldPart(item.value)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }